/// <reference types="@angular/localize" />

import '@angular/localize/init';
import { APP_INITIALIZER } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { provideRouter, withPreloading } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { AuthInterceptor } from './app/core/interceptors/auth.interceptor';
import { PermissionPreloadStrategy } from './app/core/strategies/permission-preload.strategy';
import { initGlobalInputPlainTextNormalize } from './app/core/utils/input-text-normalize';

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(
      routes,
      withPreloading(PermissionPreloadStrategy)
    ),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [DOCUMENT],
      useFactory: (doc: Document) => () => {
        initGlobalInputPlainTextNormalize(doc);
      }
    }
  ]
}).catch(err => console.error(err));

